import React from 'react';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm'
import incomingClassesModule from './IncomingAgent.module.scss';
import messageBubbleClassesModule from '../MessageBubble.module.scss';
import { getUiConfig } from '../../../../utils/config';

function IncomingAgent(props) {
  const incomingClasses = [incomingClassesModule.IncomingAgent, messageBubbleClassesModule.MessageBubble];
  const configAgent = getUiConfig().agent_messages ?? {};
  const bubbleStyles = {
    color: configAgent.text_color ?? undefined,
    backgroundColor: configAgent.bubble_color ?? undefined,
    fontSize: configAgent.font_size ?? undefined,
    fontFamily: configAgent.font_family ?? undefined,
    boxShadow: configAgent.shadow ?? undefined,
    lineHeight: configAgent.line_height ?? undefined,
    padding: configAgent.padding ?? undefined,
  }

  if (props.isTop) {
    incomingClasses.push(incomingClassesModule.top);
  }
  if (props.isBottom) {
    incomingClasses.push(incomingClassesModule.bottom);
  }

  return (
    <div>
      <div className={incomingClasses.join(' ')} style={bubbleStyles}>
        <ReactMarkdown 
          children={props.message.text} 
          remarkPlugins={[remarkGfm]} 
          linkTarget="_blank"
        />
      </div>
      {props.isBottom ? (
        <div className={messageBubbleClassesModule.timeStamp}>
          {props.timeStamp}
        </div>
      ) : null}
    </div>
  );
}

IncomingAgent.propTypes = {
  message: PropTypes.object,
  isTop: PropTypes.bool,
  isBottom: PropTypes.bool,
  timeStamp: PropTypes.string
};

export default IncomingAgent;
